import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class PersistentDropdownService {
  constructor(private storage: Storage) {}

  getSelectedValue(dropdownName: string, defaultValue: string): string {
    return this.storage.getValue(dropdownName) || defaultValue
  }
}
